import {getIrdaTrigger, updateIrdaTrigger} from "./state";
import _ from 'lodash';
import {IrdaStatus} from "../enums/irda-status";

export const updateIrdaSettings = (irdaKey: string, status: boolean) => {
    return updateIrdaTrigger(createIrdaTrigger(irdaKey, status));
}

export const getIrdaSettings = (irdaKey: string, status: boolean) => {
    return getIrdaTrigger().then(
        (res) => mapIrda(irdaKey, status, res.data)
    )
}

const mapIrda = (irdaKey: string, status: boolean, data: any) => {
    const key = irdaKey.replace('irda', 'Irda');
    const statusKey = status ? 'ON' : 'OFF';
    return _.get(data.state.desired, key + statusKey, _.get(data.state.reported, key + statusKey, ));
}

const createIrdaTrigger = (irdaKey: string, status: boolean) => {
    return {
        [irdaKey.replace('irda', 'Irda').concat(status ? 'ON' : 'OFF')]: IrdaStatus.TRIGGER
    };
}